var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.6,
    height: 18,
    viewBox: "0 0 25.6 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    d: "M26.115,7.316a3.217,3.217,0,0,0-2.263-2.278c-2-.538-10-.538-10-.538s-8.005,0-10,.538A3.217,3.217,0,0,0,1.585,7.316a33.744,33.744,0,0,0-.535,6.2,33.744,33.744,0,0,0,.535,6.2,3.169,3.169,0,0,0,2.263,2.242c2,.538,10,.538,10,.538s8.005,0,10-.538a3.169,3.169,0,0,0,2.263-2.242,33.744,33.744,0,0,0,.535-6.2,33.744,33.744,0,0,0-.535-6.2ZM11.232,17.325V9.712l6.691,3.806-6.691,3.806Z",
    transform: "translate(-1.05 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.31b2cfc5b074a9b0b10fc6722700da00.svg";
export { ForwardRef as ReactComponent };